import * as ReactDOM from 'react-dom'

import { HashRouter as Router, Route, Switch } from 'react-router-dom'

import { ApolloProvider } from '@apollo/client'
import client from './apolloClient'

import { AdminProvider } from './providers/AdminProvider'
import RadarsPage from './pages/RadarsPage'
import RadarsPageOld from './pages/RadarsPageOld'
import UsersPage from './pages/UsersPage'
import AccountsPage from './pages/AccountsPage'
import NewLawsPage from './pages/NewLawsPage'

import './styles/tailwind.css'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={RadarsPage} />
        <Route path="/old" component={RadarsPageOld} />
        <Route path="/new_laws" component={NewLawsPage} />
        <Route path="/users" component={UsersPage} />
        <Route path="/accounts" component={AccountsPage} />
      </Switch>
    </Router>
  )
}

ReactDOM.render(
  <ApolloProvider client={client}>
    <AdminProvider>
      <App />
    </AdminProvider>
  </ApolloProvider>,
  document.getElementById('app'),
)
